module.exports = __webpack_public_path__ + "img/chips500.57e19116.webp";